import { HTTP } from '../../axios_api/http-common';

const state = {
	rigTerrainSettings: [],
	wellFluidSettings: [],
	projectSettings: [],
	timeSettings: [
		{ id: '8', property: 'Year', color: '#E63316' },
		{ id: '9', property: 'Month', color: '#4383D6' },
		{ id: '10', property: 'Week', color: '#3D9BC9' },
	],
	companyProfile: {},
	nptSettings: [],
	contractorAndServices: [],
};

interface IState {
	rigTerrainSettings: ISettings[];
	wellFluidSettings: ISettings[];
	projectSettings: ISettings[];
	timeSettings: ISettings[];
	projectBarSettings: ISettings[];
	companyProfile: ICompanyProfile;
	nptSettings: INptSetting[];
	contractorAndServices: IContractorAndServices[];
}

interface IContractorAndServices {
	id: string;
	contractor: string;
	services: string[];
}

interface INptSetting {
  id: string;
  nptCategory: string;
  rootCauses: string[]
}

interface ISettings {
	id: string;
	property: string;
	color: string;
}

interface ICompanyProfile {
	CompanyName: string;
	Email: string;
	PhoneNumber: string;
	State: string;
	Country: string;
	Address: string;
	companylogo?: string;
}

const mutations = {
	setSettingsRig(state: IState, payload: ISettings[]) {
		state.rigTerrainSettings = payload;
	},
	setSettingsWell(state: IState, payload: ISettings[]) {
		state.wellFluidSettings = payload;
	},
	setNptSettings(state: IState, payload: INptSetting[]) {
		state.nptSettings = payload;
	},
	setContractorAndServices(state: IState, payload: IContractorAndServices[]) {
		state.contractorAndServices = payload;
	},
	setCompanyProfile(state: IState, payload: ICompanyProfile) {
		state.companyProfile.CompanyName = payload.CompanyName;
		state.companyProfile.Email = payload.Email;
		state.companyProfile.PhoneNumber = payload.PhoneNumber;
		state.companyProfile.State = payload.State;
		state.companyProfile.Country = payload.Country;
		state.companyProfile.Address = payload.Address;

		if (payload.companylogo && payload.companylogo.length > 0) {
			state.companyProfile.companylogo =
				HTTP.defaults.baseURL + '/files/opendownload/' + payload.companylogo;
		}
	},
	setSettingsProject(state: IState, payload: ISettings[]) {
		state.projectSettings = payload;
	},
	setTimeSettings(state: IState, payload: ISettings[]) {
		state.timeSettings = payload;
	},
	createColorSetting(state: IState, payload: any) {
		state.wellFluidSettings.push(payload);
	},
	createNptSetting(state: IState, payload: any) {
		state.nptSettings.push(payload);
	},
	createContractorAndServices(state: IState, payload: any) {
		state.contractorAndServices.push(payload);
	},
	updateColorSetting(state: IState, payload: any) {
		let foundSetting = state.wellFluidSettings.find(
			(setting) => setting.id === payload.id
		);
		foundSetting = { ...payload };
	},
	updateNptSettings(state: IState, payload: any) {
		let foundSetting = state.nptSettings.find(
			(setting) => setting.id === payload.id
		);
		foundSetting = { ...payload };
	},
	updateContractorAndServices(state: IState, payload: any) {
		let foundSetting = state.contractorAndServices.find(
			(setting) => setting.id === payload.id
		);
		foundSetting = { ...payload };
	},
	// setProjectBarSettings(state: IState, payload: ISettings[]) {
	//     state.projectBarSettings = payload
	// }
	deleteNptSettings(state: IState, deletedIds: string[]) {
		state.nptSettings = state.nptSettings.filter(
			(setting) => !deletedIds.includes(setting.id)
		);
	},
	deleteContractorAndServices(state: IState, deletedIds: string[]) {
		state.contractorAndServices = state.contractorAndServices.filter(
			(setting) => !deletedIds.includes(setting.id)
		);
	},
	deleteColorSettings(state: IState, deletedIds: string[]) {
		state.wellFluidSettings = state.wellFluidSettings.filter(
			(setting) => !deletedIds.includes(setting.id)
		);
		state.projectSettings = state.projectSettings.filter(
			(setting) => !deletedIds.includes(setting.id)
		);
		state.rigTerrainSettings = state.rigTerrainSettings.filter(
			(setting) => !deletedIds.includes(setting.id)
		);
	},
};

const getters = {
	getSettingsRig(state: IState, payload: ISettings[]) {
		return state.rigTerrainSettings;
	},
	getSettingsWell(state: IState, payload: ISettings[]) {
		return state.wellFluidSettings;
	},
	getCompanyProfile(state: IState, payload: ICompanyProfile) {
		return state.companyProfile;
	},
	getSettingsProject(state: IState, payload: ISettings[]) {
		return state.projectSettings;
	},
	getContractorAndServices(state: IState, payload: IContractorAndServices[]) {
		return state.contractorAndServices;
	},
	getTimeSettings(state: IState, payload: ISettings[]) {
		return state.timeSettings;
	},
	// getProjectBarSettings(state: IState, payload: ISettings[]) {
	//     return state.projectBarSettings
	// },
	getNptSettings(state: IState, payload: INptSetting[]) {
		return state.nptSettings;
	},
	getSettings(state: IState) {
		return [
			...state.rigTerrainSettings,
			...state.wellFluidSettings,
			...state.timeSettings,
			...state.projectBarSettings,
			...state.projectSettings,
			...state.nptSettings,
			...state.contractorAndServices,
			state.companyProfile,
		];
	},
};

const actions = {
	getColorSettings({ commit }: { commit: any }) {
		return new Promise((resolve, reject) => {
			HTTP.get('ColorSettings')
				.then((response: any) => {
					commit(
						'setSettingsWell',
						response.data.data.filter((d: any) => d.settingType === 'FluidType')
					);
					commit(
						'setSettingsProject',
						response.data.data.filter(
							(d: any) => d.settingType === 'ProjectClass'
						)
					);
					commit(
						'setSettingsRig',
						response.data.data.filter((d: any) => d.settingType === 'Terrain')
					);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	getCompanyProfile({ commit }: { commit: any }) {
		return new Promise((resolve, reject) => {
			HTTP.post('appsettings/keys', [
				'CompanyName',
				'Email',
				'PhoneNumber',
				'State',
				'Country',
				'Address',
				'CompanyLogo',
			])
				.then((response: any) => {
					commit('setCompanyProfile', response.data.data);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	updateColorSetting({ commit }: { commit: any }, payload: any) {
		return new Promise((resolve, reject) => {
			HTTP.put(`ColorSettings/${payload.id}`, payload)
				.then((response: any) => {
					commit('updateColorSetting', payload);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	mutateColorSetting({ commit }: { commit: any }, colorSettings: []) {
		return new Promise((resolve, reject) => {
			HTTP.post('ColorSettings', colorSettings)
				.then((res: any) => {
					commit('createColorSetting', res.data.data);
					resolve(res);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	deleteColorSettings({ commit }: { commit: any }, ids: string[]) {
		return new Promise((resolve, reject) => {
			HTTP.delete('ColorSettings', { data: ids })
				.then((response: any) => {
					commit('deleteColorSettings', ids);
					resolve(response);
				})
				.catch((err: any) => {
					reject(err);
				});
		});
	},
	deleteNptSettings({ commit }: { commit: any }, ids: string[]) {
		return new Promise((resolve, reject) => {
			HTTP.delete('NPTOperation/npt-type', { data: ids })
				.then((response: any) => {
					commit('deleteNptSettings', ids);
					resolve(response);
				})
				.catch((err: any) => {
					reject(err);
				});
		});
	},
	createNptSetting({ commit }: { commit: any }, nptSetting: INptSetting) {
		return new Promise((resolve, reject) => {
			HTTP.post('NPTOperation/npt-type', nptSetting)
				.then((res: any) => {
					commit('createNptSetting', res.data.data);
					resolve(res);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	getNptSettings({ commit }: { commit: any }) {
		return new Promise((resolve, reject) => {
			HTTP.get('NPTOperation/npt-type')
				.then((response: any) => {
					commit('setNptSettings', response.data.data);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	updateNptSettings(
		{ commit }: { commit: any },
		payload: { id: string; nptSetting: INptSetting }
	) {
		return new Promise((resolve, reject) => {
			HTTP.put(`NPTOperation/npt-type/${payload.id}`, payload.nptSetting)
				.then((response: any) => {
					commit('updateNptSettings', response.data.data);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
	createContractorAndServices(
		{ commit }: { commit: any },
		contractorAndServices: IContractorAndServices
	) {
		return new Promise((resolve, reject) => {
			HTTP.post('contractor-and-services/create', contractorAndServices)
				.then((res: any) => {
					commit('createContractorAndServices', res.data.data);
					resolve(res);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
  getContractorAndServices({ commit }: { commit: any }) {
		return new Promise((resolve, reject) => {
			HTTP.get('contractor-and-services')
				.then((response: any) => {
					commit('setContractorAndServices', response.data.data);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
  updateContractorAndServices(
		{ commit }: { commit: any },
		payload: { id: string; contractorAndServices: IContractorAndServices }
	) {
		return new Promise((resolve, reject) => {
			HTTP.put(`contractor-and-services/update/${payload.id}`, payload.contractorAndServices)
				.then((response: any) => {
					commit('updateContractorAndServices', response.data.data);
					resolve(response);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	},
  deleteContractorAndServices({ commit }: { commit: any }, ids: string[]) {
		return new Promise((resolve, reject) => {
			HTTP.delete('contractor-and-services/delete', { data: ids })
				.then((response: any) => {
					commit('deleteContractorAndServices', ids);
					resolve(response);
				})
				.catch((err: any) => {
					reject(err);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
